<template>
  <ItemDialog ref="DialogLoading" :image-type="isTimeout ? 'alert' : 'loader'">
    <template v-if="isTimeout" #content-area>
      <p class="text-center">
        動作に時間がかかっています。<br />
        電波の良いところでもう一度お試しください。
      </p>
    </template>
    <template v-if="isTimeout" #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";
import { useStore } from "vuex";
export default {
  name: "DialogLoading",
  props: {
    timeoutSeconds: {
      type: Number,
      required: false,
      default: 60000,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const timer = ref(null);
    const isTimeout = ref(false);
    const store = useStore();
    const openDialog = () => {
      // タイマーは開始しない（手動開始にする）
      DialogLoading.value.open();
    };

    const pauseTimer = () => {
      if (timer.value) {
        clearTimeout(timer.value);
        timer.value = null;
      }
    };

    const resumeTimer = () => {
      if (!timer.value && !isTimeout.value) {
        timer.value = setTimeout(timeout, props.timeoutSeconds);
      }
    };

    const closeDialog = () => {
      if (isTimeout.value) {
        resetDialog();
        store.commit("common/setIsReloadComponent", true);
      } else {
        resetDialog();
      }
    };

    const resetDialog = () => {
      isTimeout.value = false;
      clearTimeout(timer.value);
      DialogLoading.value.close();
    };

    const returnTopPage = () => {
      closeDialog();
      nativeHandlerService.returnNativeAppTopPage();
    };

    const timeout = () => {
      isTimeout.value = true;
    };

    return {
      DialogLoading,
      isTimeout,
      openDialog,
      closeDialog,
      returnTopPage,
      pauseTimer,
      resumeTimer,
    };
  },
};
</script>
